import Uppy from '@uppy/core';
import i18n from 'i18n';
import { CUSTOM_BACKGROUND_UPLOADER_CONFIG } from 'features/virtual-backgrounds/constants';

export function createVirtualBackgroundUppyInstance(): Uppy {
  return new Uppy({
    id: 'vb-uploader',
    debug: process.env.NODE_ENV === 'development',
    restrictions: {
      maxFileSize: CUSTOM_BACKGROUND_UPLOADER_CONFIG.MAX_FILE_SIZE,
      allowedFileTypes: CUSTOM_BACKGROUND_UPLOADER_CONFIG.SUPPORTED_FORMATS,
      maxNumberOfFiles: CUSTOM_BACKGROUND_UPLOADER_CONFIG.MAX_NUMBER_OF_FILES,
    },
    locale: {
      pluralize(n: number) {
        return n === 1 ? 0 : 1;
      },
      strings: {
        addedNumFiles: i18n.t('settings:virtual_bg.uploader_errors.addedNumFiles'),
        additionalRestrictionsFailed: i18n.t(
          'settings:virtual_bg.uploader_errors.additionalRestrictionsFailed'
        ),
        exceedsSize: i18n.t('settings:virtual_bg.uploader_errors.exceedsSize'),
        failedToUpload: i18n.t('settings:virtual_bg.uploader_errors.failedToUpload'),
        error: i18n.t('settings:virtual_bg.uploader_errors.error'),
      },
    },
  });
}
